export interface LinkAuthorizationReponse {
	status:number;
	type:LinkAuthorizationErrorType;
	title:string;
	instance:string;
	errors:any[];
}

export interface LinkAuthorizationResponseLegacy {
	InvalidPassword?:boolean;
	InvalidPin?:boolean;
	InvalidAccessCode?:boolean;
}

export enum LinkAuthorizationErrorType {
	InvalidPassword = '/invalid_password',
	InvalidAccessCode = '/invalid_accesscode'
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/link-authorization-response.ts